import { Injectable } from '@angular/core';
import { MddHttpService } from './mdd-http.service';
import { GetApi } from '../../../mdd-api/src/domain/interactors';
import { CreateResource } from 'app/domain/interactors/resources';

@Injectable()
export class UserActivityService {
    private getApi: GetApi;
    persistUserLogin: CreateResource<null>;

    constructor(mddHttp: MddHttpService) {
        this.getApi = new GetApi(mddHttp);
        this.persistUserLogin = new CreateResource(mddHttp);
    }

    trackUserActivity() {
        this.getApi.execute().then((api) => {
            this.persistUserLogin
                .execute({
                    parent: api,
                    rel: 'user-activity',
                    method: 'POST'
                })
                .then(() => {})
                .catch(() => {});
        });
    }
}
